import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBookedFromDeveloperEnabled } from 'shared/selectors';

import { NewbuildingBookedOverlay } from '../../components/NewbuildingBookedOverlay';
import { selectIsBookedFromDeveloper } from '../../selectors/newbuildingBookedFromDeveloper';

export const NewbuildingBookedOverlayContainer = () => {
  const isBooked = useSelector(selectIsBookedFromDeveloper);
  const bookedFromDeveloperEnabled = useSelector(selectBookedFromDeveloperEnabled);

  if (!isBooked || bookedFromDeveloperEnabled) {
    return null;
  }

  return <NewbuildingBookedOverlay />;
};
